module.exports = __webpack_public_path__ + "img/service_8.svg";